import React, { Component } from "react";

export default class ContactPersonImg extends Component {
  render() {
    const theme = this.props.theme;
    return (
      <svg
        id="contact-person-illustration"
        xmlns="http://www.w3.org/2000/svg"
        width="100%"
        height="100%"
        viewBox="0 0 580.83019 840.46931"
      >
        <title>Contact Person</title>
        <rect
          x="207.3502"
          y="347.40723"
          width="115"
          height="127"
          fill={theme.dark}
        />
        <path
          d="M207.93998,210.99916l-32.03704,89.14636-32.03665-7.36666,39.52706-90.5425c-2.93298-5.95002-3.43099-13.64607-.7573-21.13569,4.67827-13.1049,17.26259-20.58982,28.10803-16.71817,10.84543,3.87169,15.84487,17.63372,11.16659,30.73866-2.6737,7.48966-7.93298,13.13038-13.97068,15.87801Z"
          fill="#ffb8b8"
        />
        <path d="M210.07285,213.00391c-.29395,0-.59082-.0332-.88379-.10254-1.13965-.2666-2.08496-1.02441-2.59277-2.0791l-9.92773-20.6084c-.57129-1.18555-.50098-2.56348.1875-3.68555l22.72559-37.06641c.61523-1.00293,1.63867-1.66211,2.80566-1.80859l4.09473-.51172c1.5791-.19238,3.14941.62012,3.89062,2.03516l9.02344,17.22656c.63574,1.21484.5752,2.68848-.15723,3.84863l-25.91602,40.95898c-.23926.37695-.53809.70605-.8877.97852-.68555.53418-1.51465.81445-2.3623.81445Z" />
        <path
          d="M210.99961,204.95215c-.11914,0-.23926-.00684-.36035-.02148-1.11719-.13281-2.05762-.87012-2.45312-1.92383l-5.00781-13.33887c-.32715-.87207-.23633-1.82715.24902-2.62012l19.92285-32.56934c.54102-.88477,1.48242-1.4209,2.51953-1.43457,1.08008.0127,1.99414.5,2.55957,1.37109l7.94043,12.27051c.65625,1.01367.6416,2.31641-.03711,3.31641l-22.85645,33.63672c-.56348.83008-1.49023,1.31348-2.47656,1.31348Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M306.93661,150.92243c1.18598-25.45958-18.4917-47.06012-43.95127-48.2461-25.45958-1.18598-47.06029,18.49169-48.24628,43.95126-.96184,20.6479,11.80004,38.7552,30.23841,45.49557l6.16814,59.3107,47.19415-35.74246s-9.23204-12.95832-13.83871-27.29924c12.82439-7.67595,21.68796-21.4208,22.43556-37.46973Z"
          fill="#ffb8b8"
        />
        <path
          d="M294.3502,196.84961l-49,16-2,13-33,169,13,15s-13.5,5.5-4.5,17.5l-5,16s51,38,119,4l-23-238-15.5-12.5Z"
          fill={theme.imageHighlight}
        />
        <path
          d="M224.8502,441.34961l-11,2-6,25-6,5,4,8-4,11.83566s-16,67.16434-11,127.16434l-.96786,153.3798,39.96786,9.6202,8-14,4-139,29-105,27,106,11,12,35,69s30,2,32-28c0,0-15-74-34-86l2.45427-136.8605-11.45427-14.1395-108-6Z"
          fill={theme.dark}
        />
        <polygon
          points="227.8502 776.34961 230.8502 804.34961 194.8502 800.34961 196.8502 768.34961 227.8502 776.34961"
          fill="#ffb8b8"
        />
        <path
          d="M235.8502,797.34961s-14,16-25-9c0,0-3-17-22-9l-25.19397,23.04278s-28.80603.95722-27.80603,18.95722c0,0,9,18,57,17s43-1.61604,43-1.61604v-39.38396Z"
          fill={theme.dark}
        />
        <path
          d="M339.8502,708.34961l2,19-8,24s-14,35,8,35,34-23.09619,34-23.09619c0,0,7-28.90381,4-43.90381,0,0,10.38802-30.02172-5.30599-41.01086l-34.69401,30.01086Z"
          fill={theme.dark}
        />
        <path
          d="M246.3502,205.40723l-20.5,15.94238s-15,3-21,9-39-15-47,11l-20,33-19,26v39.03784l20,13.96216s50-14,57-27c0,0-18.1686,86-11.0843,112.5l-3.1545,26.5,24.2388,16,18.5-158.94238,24.5-99.05762-2.5-17.94238Z"
          fill={theme.dark}
        />
        <path
          d="M278.33311,118.47369c-5.3314,2.21898-11.79365,1.46056-16.46641-1.93253-11.43803,6.17695-25.19548,7.92776-37.81605,4.81257-1.88018,4.99199-5.66872,9.23796-10.41507,11.67257-.18698-6.91067,2.18308-13.86173,6.55288-19.2187-3.96687,1.78282-7.93375,3.56563-11.90062,5.34845,2.96195-4.27825,5.9239-8.55651,8.88585-12.83476l.67553-.58382c-3.58012-.97973-7.16024-1.95947-10.74035-2.9392,6.76984-3.48936,14.6455-4.79209,22.17837-3.66855-1.32103-3.11679-4.31282-5.46497-7.65424-6.00759,7.90098-1.67243,15.80197-3.34485,23.70295-5.01728l-.27027.9727c10.59787-2.38827,21.50321-4.78949,32.23596-3.10823s21.40144,8.41875,24.44858,18.84629l.05042-.55935c6.43502.14088,12.72609,3.44278,16.49742,8.65875,3.77133,5.21597,4.93535,12.22491,3.05248,18.37991-2.25845,7.38275-8.59058,13.66329-8.25933,21.37665l-.29044.06028c2.09668,11.77987-18.50922,29.01721-28.45057,35.67537,4.21228-1.96454,9.19214-9.50762,8-14-1.19214-4.49238,9.63211-21.3825,5-21-2.60025.21472-16.71389-3.72636-18.65707-9.36113-1.63712-4.74727-3.28809-9.87887-1.85315-14.69111.56611-1.89851,1.59126-3.63809,2.12362-5.54633s.46986-4.17371-.89854-5.60629"
          fill={theme.dark}
        />
        <path
          d="M188.10676,295.71365l19.24343-70.36404s-20.73026,14-33.34868-11l-35.15132,59"
          fill={theme.dark}
        />
        <path
          d="M351.29725,479.50319l32.03704-89.14636,32.03665,7.36666-39.52706,90.5425c2.93298,5.95002,3.43099,13.64607.7573,21.13569-4.67827,13.1049-17.26259,20.58982-28.10803,16.71817-10.84543-3.87169-15.84487-17.63372-11.16659-30.73866,2.6737-7.48966,7.93298-13.13038,13.97068-15.87801Z"
          fill="#ffb8b8"
        />
        <path
          d="M503.60892,840.46931H2.17174c-1.29421-.09892-2.25044-1.22414-2.16663-2.51834-.08381-1.28047.87242-2.40569,2.16663-2.50461h501.43718c1.14033.14014,2.04023,1.04141,2.18037,2.18037.18273,1.39313-.78724,2.65848-2.18037,2.84258Z"
          fill={theme.text}
        />
        <path
          d="M284.3502,193.40723s29.5-1.05762,30.5,15.94238l58,24,47,141s-14,84-30,96l-10,26s-2-20-32-19l1-12s-32,26-57,19c0,0-28.96786-187.16874-8.98393-230.58437,0,0,12.48393-57.35801,1.48393-60.35801Z"
          fill={theme.dark}
        />
        <polygon
          points="349.33848 465.45605 348.36192 465.24316 365.33555 387.36426 347.36192 322.84766 348.32481 322.58008 366.36484 387.33496 349.33848 465.45605"
          fill={theme.body}
        />
        <rect
          x="487.12852"
          y="218.97168"
          width="36.18262"
          height="1"
          fill={theme.dark}
        />
        <rect
          x="487.12852"
          y="238.89258"
          width="67.18359"
          height="1"
          fill={theme.dark}
        />
        <rect
          x="487.12852"
          y="256.73633"
          width="67.18359"
          height="1"
          fill={theme.dark}
        />
        <circle
          cx="383.22305"
          cy="56.5823"
          r="10.19673"
          fill={theme.imageHighlight}
        />
        <circle
          cx="408.71487"
          cy="56.5823"
          r="10.19673"
          fill={theme.imageHighlight}
        />
        <circle
          cx="434.20669"
          cy="56.5823"
          r="10.19673"
          fill={theme.imageHighlight}
        />
        <path
          d="M368.16074,118.33008c-.78125,0-1.56641-.21094-2.28906-.63672-1.59766-.94141-2.42773-2.66699-2.16504-4.50391l2.65039-18.55566c-13.90527-10.27246-21.87207-25.05371-21.87207-40.60059,0-29.79395,28.81348-54.0332,64.23047-54.0332s64.22852,24.23926,64.22852,54.0332-28.8125,54.03223-64.22852,54.03223c-7.34375,0-14.55664-1.04004-21.44141-3.09082l-16.41211,12.42969c-.81152.61426-1.75293.9248-2.70117.92578ZM408.71543,1c-34.86523,0-63.23047,23.79102-63.23047,53.0332,0,15.31348,7.91113,29.88281,21.7041,39.97168l.24219.17676-2.73438,19.14941c-.2041,1.42773.44043,2.76953,1.68262,3.50098,1.24219.73242,2.72754.64551,3.87891-.22461l16.81738-12.73633.24316.07324c6.86523,2.07129,14.06348,3.12109,21.39648,3.12109,34.86426,0,63.22852-23.79004,63.22852-53.03223S443.57969,1,408.71543,1Z"
          fill={theme.dark}
        />
        <path
          d="M156.35508,149.16406H52.2877c-2.50781,0-4.54883-2.04004-4.54883-4.54785v-65.83008c0-2.50781,2.04102-4.54785,4.54883-4.54785h104.06738c2.50781,0,4.54785,2.04004,4.54785,4.54785v65.83008c0,2.50781-2.04004,4.54785-4.54785,4.54785ZM52.2877,75.23828c-1.95703,0-3.54883,1.5918-3.54883,3.54785v65.83008c0,1.95605,1.5918,3.54785,3.54883,3.54785h104.06738c1.95605,0,3.54785-1.5918,3.54785-3.54785v-65.83008c0-1.95605-1.5918-3.54785-3.54785-3.54785H52.2877Z"
          fill={theme.dark}
        />
        <polygon
          points="104.31602 122.58008 104.00547 122.3291 56.84629 84.04883 57.47715 83.27148 104.32578 121.30078 152.66074 83.26758 153.27988 84.05273 104.31602 122.58008"
          fill={theme.dark}
        />
        <rect
          x="54.43626"
          y="125.22201"
          width="42.54467"
          height=".99933"
          transform="translate(-64.06446 80.98663) rotate(-41.19646)"
          fill={theme.dark}
        />
        <rect
          x="136.02737"
          y="102.51503"
          width="1.00014"
          height="45.52463"
          transform="translate(-48.37876 137.27122) rotate(-46.25071)"
          fill={theme.dark}
        />
        <path
          d="M561.17102,311.04021h-74.68164c-10.83984,0-19.65918-8.81885-19.65918-19.65918v-80.68164c0-10.84033,8.81934-19.65918,19.65918-19.65918h74.68164c10.83984,0,19.65918,8.81885,19.65918,19.65918v80.68164c0,10.84033-8.81934,19.65918-19.65918,19.65918ZM486.48937,192.04021c-10.28906,0-18.65918,8.37061-18.65918,18.65918v80.68164c0,10.28857,8.37012,18.65918,18.65918,18.65918h74.68164c10.28906,0,18.65918-8.37061,18.65918-18.65918v-80.68164c0-10.28857-8.37012-18.65918-18.65918-18.65918h-74.68164Z"
          fill={theme.dark}
        />
      </svg>
    );
  }
}
